interface Props {
  value?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const SmallCheckbox: React.FC<Props> = ({ value, onChange }) => {
  return (
    <div className='d-flex align-items-center'>
      <div className='form-check form-check-custom form-check-sm'>
        <input
          className='form-check-input'
          type='checkbox'
          checked={value}
          onChange={(e: any) => (onChange ? onChange(e) : {})}
        />
      </div>
    </div>
  )
}

export default SmallCheckbox
